/*
 * Portal marker — a soft glowing patch of moss with a worn footpath leading
 * into it. Sits at the south edge of each zone (matching `state/zone.ts`).
 *
 * The actual proximity prompt is HTML (positioned over the canvas) — this
 * renderer is just the visual cue that says "something is here."
 */

import { Container, Graphics } from 'pixi.js';

export function createPortal(x: number, y: number): Container {
  const root = new Container();
  root.position.set(x, y);

  const g = new Graphics();

  // Worn footpath — a short tapered cream strip leading south off-screen.
  g.moveTo(-12, -10)
    .lineTo(-18, 14)
    .lineTo(18, 14)
    .lineTo(12, -10)
    .closePath()
    .fill({ color: 0xc7b48a, alpha: 0.18 });

  // Glowing moss patch — three concentric circles, ascending alpha.
  g.circle(0, 0, 26).fill({ color: 0x6ba07a, alpha: 0.12 });
  g.circle(0, 0, 18).fill({ color: 0x6ba07a, alpha: 0.18 });
  g.circle(0, 0, 10).fill({ color: 0x6ba07a, alpha: 0.28 });

  // A few stepping stones outlining the path.
  g.ellipse(-8, 4, 4, 2.5).fill(0x7a6f63);
  g.ellipse(7, 6, 4, 2.5).fill(0x7a6f63);
  g.ellipse(0, 11, 4, 2.5).fill(0x7a6f63);

  // Two small lanterns flanking the path entrance.
  for (const offsetX of [-22, 22]) {
    g.rect(offsetX - 0.8, -4, 1.6, 12).fill(0x3a2410);
    g.circle(offsetX, -6, 3).fill(0xffc56b);
    g.circle(offsetX, -6, 6).fill({ color: 0xffc56b, alpha: 0.25 });
  }

  root.addChild(g);
  return root;
}
